// import Notification from './notification'
import Bulma from './bulma'
import Axios from './axios'
import Draggable from './draggable'
import ContentLoading from './mock-content'
import Dialog from './dialog'
import Datepicker from './date-picker'
import MultiSelect from './multi-select'

export default (Vue) => {
    Vue.use(Bulma)
    Vue.use(Dialog)
    Vue.use(Datepicker)
    Vue.use(MultiSelect)
}


